var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},[_c('ul',_vm._l((_vm.breadcrumbsList),function(breadcrumb,i){return _c('li',{key:i},[_c('span',[_vm._v(_vm._s(breadcrumb.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }